import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { openMapAroundMe } from '../lib/geo';

const FONT = 'Manrope, system-ui, sans-serif';

export default function ProspectProfile() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const name = user?.name || 'Profilo';
  const initial = (name.charAt(0) || 'P').toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ flex: 1, minHeight: 0, height: '100%', overflowY: 'auto', WebkitOverflowScrolling: 'touch', background: '#F6F7F9', fontFamily: FONT }}>
      <div style={{ padding: 'calc(20px + env(safe-area-inset-top, 0px)) 18px 10px' }}>
        <div style={{ fontSize: 24, fontWeight: 900, color: '#1F2937', letterSpacing: '-0.02em' }}>Profilo</div>
      </div>

      <div style={{ padding: '4px 18px calc(96px + env(safe-area-inset-bottom, 0px))' }}>
        {/* Header utente */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, background: '#fff', border: '1px solid #EEF0F2', borderRadius: 20, padding: 18, marginBottom: 18 }}>
          <div style={{ width: 54, height: 54, borderRadius: '50%', background: 'linear-gradient(135deg,#1F6FEB,#16915E)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 900, flex: '0 0 auto' }}>{initial}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 17, fontWeight: 900, color: '#1F2937' }}>{name}</div>
            <div style={{ fontSize: 13, color: '#6B7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email || user?.phone || ''}</div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, marginTop: 6, fontSize: 11.5, fontWeight: 800, color: '#16915E', background: '#E9F7EF', borderRadius: 999, padding: '3px 10px' }}><span>●</span> Radar Pro</div>
          </div>
        </div>

        {/* Logout */}
        <button onClick={handleLogout} style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 13, textAlign: 'left',
          background: '#fff', border: '1px solid #F3D6D2', borderRadius: 16, padding: 14, marginTop: 6, cursor: 'pointer',
        }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, background: '#FBE9E7', display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2453B" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5M21 12H9" /></svg>
          </div>
          <span style={{ fontSize: 14.5, fontWeight: 800, color: '#C2453B' }}>Esci</span>
        </button>
      </div>

      {/* Bottom tab bar */}
      <nav style={{
        position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 60,
        display: 'flex', background: '#fff', borderTop: '1px solid #ECEDEF',
        boxShadow: '0 -2px 12px rgba(0,0,0,0.06)', paddingBottom: 'env(safe-area-inset-bottom, 0px)', fontFamily: FONT,
      }}>
        {[
          { id: 'cerca', label: 'Cerca', onClick: () => navigate('/app/home'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke={c} strokeWidth="1.9"/><path d="M21 21l-4.3-4.3" stroke={c} strokeWidth="1.9" strokeLinecap="round"/></svg>) },
          { id: 'mappa', label: 'Mappa', onClick: () => openMapAroundMe(navigate),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11Z" stroke={c} strokeWidth="1.8" strokeLinejoin="round"/><circle cx="12" cy="10" r="2.4" stroke={c} strokeWidth="1.8"/></svg>) },
          { id: 'preferiti', label: 'Preferiti', onClick: () => navigate('/app/mappa?view=preferiti'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M12 21s-7-4.35-9.5-8.5C1 9.5 2.5 5.5 6.5 5.5c2 0 3.5 1.5 5.5 3.5 2-2 3.5-3.5 5.5-3.5 4 0 5.5 4 4 7C19 16.65 12 21 12 21z" stroke={c} strokeWidth="1.8" strokeLinejoin="round"/></svg>) },
          { id: 'analizzati', label: 'Analizzati', onClick: () => navigate('/app/analizzati'),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><path d="M4 5h16M4 12h16M4 19h10" stroke={c} strokeWidth="1.8" strokeLinecap="round"/><circle cx="19.5" cy="18.5" r="3" stroke={c} strokeWidth="1.8"/><path d="M21.7 20.7L23 22" stroke={c} strokeWidth="1.8" strokeLinecap="round"/></svg>) },
          { id: 'profilo', label: 'Profilo', active: true, onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
            icon: (c) => (<svg width="23" height="23" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke={c} strokeWidth="1.8"/><path d="M4 20c0-4 3.6-6 8-6s8 2 8 6" stroke={c} strokeWidth="1.8" strokeLinecap="round"/></svg>) },
        ].map((t) => {
          const col = t.active ? '#1F6FEB' : '#9AA0A6';
          return (
            <button key={t.id} onClick={t.onClick} style={{
              flex: 1, border: 0, background: 'transparent', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '9px 0 8px', color: col,
            }}>
              {t.icon(col)}
              <span style={{ fontSize: 11, fontWeight: t.active ? 700 : 600, letterSpacing: '-0.01em' }}>{t.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
